<template>
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4 8.5 11 4l7 4.5v7L11 20l-7-4.5v-7Z" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round" />
        <circle cx="11" cy="12" r="2.3" stroke="currentColor" stroke-width="1.6" />
    </svg>
</template>